import { reactive } from "@vue/composition-api";
import { io } from "socket.io-client";
import store from "@/store";

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: [],
  modificarComandaAll: 0, 
  modificarComanda: 0
});

// "undefined" means the URL will be computed from the `window.location` object

const URL = (config.VUE_APP_URL_SOCKET || process.env.VUE_APP_URL_SOCKET)    
export const socket = io(URL);

socket.on("connect", () => {
  state.connected = true; 
  if (store.state.user.usuario) {
    
    socket.emit('join', { usuario: store.state.user.usuario })
  } 
});
socket.on('modificar-comanda-all', (...args) => { 
  state.modificarComandaAll = state.modificarComandaAll + 1
})
socket.on("disconnect", () => {
  state.connected = false;
}); 

socket.on('modificar-comanda', (...args) => {
  state.modificarComanda = state.modificarComanda + 1
}); 
 

 
